// extracted by mini-css-extract-plugin
export default {"header":"UnifiedTcTokenRowView_header__IwXYY","id":"UnifiedTcTokenRowView_id__abu-9","token":"UnifiedTcTokenRowView_token__tgLlC","footer":"UnifiedTcTokenRowView_footer__ldR7+"};